module.exports = __webpack_public_path__ + "img/aws-black.7bd3ce4f.png";